/**
 * The one API the console talks to, fixed at build time.
 *
 * `VITE_API_URL` is baked in by the docker build (deploy sets it to the
 * deployed API origin); a dev build falls back to the local API. There is
 * deliberately no remote fallback: a wrong guess here would send an admin
 * bearer token to whoever owns the guessed domain.
 */
export type RawEnv = Readonly<Record<string, string | undefined>>;

/** Exported for tests; the app reads API_BASE_URL. */
export function resolveBaseUrl(env: RawEnv): string {
  const raw = env.VITE_API_URL?.trim();
  if (raw === undefined || raw === '') return 'http://localhost:3000';
  // A trailing slash would double up when paths are appended.
  return raw.replace(/\/+$/, '');
}

export const API_BASE_URL = resolveBaseUrl(import.meta.env);
